import React from "react";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

interface HelpTipProps {
  /** Text shown on hover. Keep it short — one or two sentences. */
  title: React.ReactNode;
  size?: number;
}

/**
 * Small "?" icon with a hover tooltip. Drop it next to a label, column header
 * or control whose purpose is not obvious, so users understand what it does.
 */
export default function HelpTip({ title, size = 15 }: HelpTipProps) {
  return (
    <Tooltip
      arrow
      placement="top"
      title={<Box sx={{ fontSize: 12.5, lineHeight: 1.55, py: 0.25 }}>{title}</Box>}
    >
      <HelpOutlineIcon
        sx={{
          fontSize: size,
          color: "#98a2b3",
          cursor: "help",
          verticalAlign: "middle",
          ml: 0.5,
          transition: "color 120ms",
          "&:hover": { color: "primary.main" },
        }}
      />
    </Tooltip>
  );
}
